import * as React from "react";
import { forwardRef } from "react";
const SvgRadioCircle = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 8, viewBox: "0 0 8 8", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 4 }));
const ForwardRef = forwardRef(SvgRadioCircle);
export default ForwardRef;
